import React, {Component} from 'react'
import {cardStyles, styles} from '../Constants'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Toggle from 'material-ui/Toggle'
import Paper from 'material-ui/Paper'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import Dialog from 'material-ui/Dialog'
import {GridList, GridTile} from 'material-ui/GridList'

import * as firebase from 'firebase'

export default class Agenda extends Component {
  constructor(props) {
    super(props)
    this.state = {
      childrenData: [],
      staff: [],
    }
  }

  signInOut = () => {
    let self = this
    firebase.auth().signOut().then(function() {
      window.location.href = "./"
    }, function(error) {
      console.error('Sign Out Error', error);
    })
  }

  acceptTheAppointment(appointment) {
    console.log(appointment)
    this.setState({
      appointmentBeingAccepted: true,
      completed: false,
    })
  }

  declineTheAppointment(appointment) {
    console.log(appointment)
    this.setState({
      appointmentBeingAccepted: false,
      completed: false,
    })
  }

  componentWillMount() {
    let self = this
    var staff = []
    var promises = []
    firebase.database().ref("info/staff/").on("value", function(theSnap) {
      if(theSnap.val()) {
        theSnap.forEach(function(child) {
          let item = child.val()
          staff.push(item)
        })
        self.setState({
          staff: staff,
        })
      }
    })
  }

  componentDidMount() {
    let self = this
    var lst = []
    firebase.database().ref("appointments/all_of_them/").orderByChild("when")
    .startAt(new Date().getTime()).on("value", function(snap) {
      if(snap.val()) {
        snap.forEach(function(child) {
          let item = child.val()
          item.key = child.key
          lst.push(item);
        })
        self.setState({
          appointmentBeingAccepted: false,
          completed: false,
          childrenData: lst,
        })
      }
    })
  }

  handleClose(shouldAssign) {
    let self = this
    if(shouldAssign) {
      console.log("do the things")
      self.setState({
        appointmentBeingAccepted: false,
        completed: true,
      })
    } else {
      console.log("cancelled")
      self.setState({
        appointmentBeingAccepted: false,
        completed: false,
      })
    }
  }

  staffSelected(staff) {
    this.setState({
      staffSelected: staff,
      appointmentBeingAccepted: true,
      completed: false,
    })
  }

  render() {
    let self = this
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={self.handleClose.bind(self, false)} />,
        <FlatButton
        label="Assign to Staff"
        primary={true}
        onClick={self.handleClose.bind(self, true)} />
      ]
      if(self.state.appointmentBeingAccepted) {
        return (
          <div>
          <Dialog
            modal={true}
            open={true}
            actions={actions}
            autoScrollBodyContent={true}>
            <div className="center">
              <img src="logo.png" width={70} height={70}/>
              <h5>Choose Staff Member</h5>
              <br/>
              <GridList
                cols={3}
                cellHeight='auto'>
                {self.state.staff.map(function(s) {
                  return (
                    self.state.staffSelected == s ?
                      <div onClick={self.staffSelected.bind(self, s)} key={s.id} style={{backgroundColor: '#493663'}}>
                        <br/>
                        <img src={s.storageRef} alt="Avatar" width={50} height="50"
                          style={{borderRadius: '50%', display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'}}/>
                        <br/>
                        <p style={{color: '#DCA3AC'}} className="center">{s.name.split(" ")[0]}</p>
                        <br/>
                      </div> :
                      <div onClick={self.staffSelected.bind(self, s)} key={s.id}>
                        <br/>
                        <img src={s.storageRef} alt="Avatar" width={50} height="50"
                          style={{borderRadius: '50%', display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'}}/>
                        <br/>
                        <p className="center">{s.name.split(" ")[0]}</p>
                        <br/>
                      </div>
                   )
                  })
                }
              </GridList>
            </div>
          </Dialog>
          <CardText
            expandable={true}>
            <h4 className="center">Agenda</h4>
            {self.state.childrenData.map(function(o) {
              return (
                <Paper key={o.key} zDepth={2}>
                  <CardHeader
                    key={o.key}
                    title={o.userName}
                    subtitle={o.date + " at " + o.time}
                    avatar={o.storageRef}/>
                    <IconMenu className="right"
                      listStyle={{backgroundColor: '#251B32'}}
                      menuItemStyle={{color: '#DCA3AC'}}
                      iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                      targetOrigin={{horizontal: 'right', vertical: 'bottom'}}>
                      <MenuItem primaryText="Accept" onClick={self.acceptTheAppointment.bind(self, o)} />
                      <MenuItem primaryText="Decline" onClick={self.declineTheAppointment.bind(self, o)}/>
                    </IconMenu>
                    <p style={{paddingBottom: '5px'}}>
                      &nbsp;&nbsp;&nbsp;&nbsp;{o.name}
                      <br/>
                      &nbsp;&nbsp;&nbsp;&nbsp;{o.status}
                    </p>
                </Paper>
              )
            })}
          </CardText>
          </div>
        )
      } else {
        return (
          <CardText
            expandable={true}>
            <h4 className="center">Agenda</h4>
            {self.state.childrenData.map(function(o) {
              return (
                <Paper key={o.key} zDepth={2}>
                  <CardHeader
                    key={o.key}
                    title={o.userName}
                    subtitle={o.date + " at " + o.time}
                    avatar={o.storageRef}/>
                    <IconMenu className="right"
                      listStyle={{backgroundColor: '#251B32'}}
                      menuItemStyle={{color: '#DCA3AC'}}
                      iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                      anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                      targetOrigin={{horizontal: 'right', vertical: 'bottom'}}>
                      <MenuItem primaryText="Accept" onClick={self.acceptTheAppointment.bind(self, o)} />
                      <MenuItem primaryText="Decline" onClick={self.declineTheAppointment.bind(self, o)}/>
                    </IconMenu>
                    <p style={{paddingBottom: '5px'}}>
                      &nbsp;&nbsp;&nbsp;&nbsp;{o.name}
                      <br/>
                      &nbsp;&nbsp;&nbsp;&nbsp;{o.status}
                    </p>
                </Paper>
              )
            })}
          </CardText>
        )
      }

  }

}



// WEBPACK FOOTER //
// ./src/react/Agenda.js